import React, { useEffect, useRef, useState } from "react"
import { Modal, Button } from 'react-bootstrap';
import LoadingSpinner from '../LoadingSpinner/index'
import { ToastContainer, toast } from 'react-toastify';


const NotesshowModal = (props) => {
  const { notesShow, setNotesShow, selectedNote, setSelectedNote} = props;
  const [isLoading, setIsLoading] = useState(false);

  const handleCloseModal = () => {
    setNotesShow(false)
  }

  useEffect(() => {
  }, [notesShow])

  return (
    <>
      <div>
        <ToastContainer
          position="top-center"
        />
        <LoadingSpinner isLoading={isLoading} />
        <Modal size="md" show={notesShow} onHide={handleCloseModal}>
          <Modal.Header closeButton>
            <Modal.Title>Notes</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div>
                <div>
                    {selectedNote ? selectedNote : 'No notes available'} 
                </div>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={handleCloseModal}>
              Close
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  )
}
export default NotesshowModal